import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
} from "reactstrap"

import TableActiveComponent from './Components/TableActiveComponent'

const IndexView = (props) => {

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        <Link to="?create">
                                            <Button color="primary">Tambah Data Laporan Penilaian SKP</Button>
                                        </Link>
                                    : null
                                }
                                </div>
                                <CardTitle>Daftar Laporan Penilaian SKP</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Laporan Penilaian SKP
                                </CardSubtitle>
                                <hr />
                                <TableActiveComponent/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView